import type { ReactNode } from 'react';

type MessageProps = {
  avatar?: ReactNode;
  name: string;
  isBot?: boolean;
  verified?: boolean;
  time?: string;
  continuation?: boolean;
  children: ReactNode;
};

export function Message({
  avatar,
  name,
  isBot = false,
  verified = false,
  time = '오늘 오후 3:14',
  continuation = false,
  children,
}: MessageProps) {
  return (
    <div className={`msg ${continuation ? 'continuation' : ''}`}>
      {continuation ? <div /> : avatar}
      <div className="body">
        {!continuation && (
          <div className="head">
            <span className={`name ${isBot ? 'bot' : ''}`}>{name}</span>
            {isBot && (
              <span className={`badge-bot${verified ? ' is-verified' : ''}`}>앱</span>
            )}
            <span className="ts">{time}</span>
          </div>
        )}
        <div className="text">{children}</div>
      </div>
    </div>
  );
}
